"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Button = require("./Button.style");

var _excluded = ["text", "icon", "onClick"];

var Button = function Button(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Button.ButtonWrapper, Object.assign({
    onClick: onClick
  }, props), text, icon ? icon : null);
};

exports.Button = Button;